<template>
	<scope v-bind="{categoryId}">
		<div class="products" slot-scope="{noItems, groups}">
			<div class="groups">
				<group v-for="group in groups" v-if="group.items.length" v-bind="group" :key="group.id"/>

				<div class="noitems" v-if="noItems && loaded">
					Ingen produkter fundet.
				</div>
			</div>
		</div>
	</scope>
</template>

<script>
import group from "./group/index.vue";
import scope from "../shared";

export default {
	components: {group, scope},
	props: {
		loaded: {type: Boolean, required: true},
		categoryId: {type: Number, required: false}
	}
};
</script>

<style lang="scss" scoped>
.products {
	margin-bottom: 4em;
}
</style>
